import { DEFAULT_APP_BASE_URL } from 'src/utils/wrongDomain';

/**
 * The shareable signup link for a referral code:
 * https://<app host>/signupnow/<referralCode>
 *
 * The host must never be hardcoded — QA, Stage and Production are different
 * hosts, and each build sets REACT_APP_APP_BASE_URL accordingly. The fallback
 * is the same DEFAULT_APP_BASE_URL that src/index.js uses, which is the app
 * host and not the connectionpointapp.com forms domain; a link built on the
 * forms domain would 404, since /signupnow is not on that domain's allowlist.
 *
 * Returns null when there is no code, so callers can hide the option.
 */
export function buildReferralSignupLink(referralCode) {
  const code = String(referralCode || '').trim();
  if (!code) {
    return null;
  }

  const base = String(process.env.REACT_APP_APP_BASE_URL || DEFAULT_APP_BASE_URL)
    .replace(/\/+$/, '');

  return `${base}/signupnow/${encodeURIComponent(code)}`;
}

export default buildReferralSignupLink;
